/* AMI Bookstore — product-row slider dots (progressive enhancement).
 *
 * For every product-row slider (featured collections, collection lists) this
 * adds an `ami-dots-ready` class (which gates all the modern CSS: glass
 * hover arrows, hidden numeric counter) and a <= 3 dot position indicator.
 * The hero slideshow (slideshow-component), the product-page gallery and
 * quick-add modals are excluded by the allowlist below. Without JS nothing
 * here runs and the theme's stock bar remains.
 */
(function () {
  'use strict';

  function initSlider(component) {
    if (component.dataset.amiDots) return;

    var slider = component.querySelector('ul.product-grid, ul.collection-list');
    var buttonsBar = component.querySelector('.slider-buttons');
    if (!slider || !buttonsBar) return;

    component.dataset.amiDots = 'true';
    component.classList.add('ami-dots-ready');

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'ami-dots';
    dotsWrap.setAttribute('role', 'group');
    dotsWrap.setAttribute('aria-label', 'List position');
    buttonsBar.insertAdjacentElement('afterend', dotsWrap);

    var dots = [];
    var labels = ['Go to beginning of list', 'Go to middle of list', 'Go to end of list'];

    function maxScroll() {
      return slider.scrollWidth - slider.clientWidth;
    }

    function rebuild() {
      var scrollable = maxScroll() > 10;
      dotsWrap.hidden = !scrollable;
      if (!scrollable) {
        dotsWrap.textContent = '';
        dots = [];
        return;
      }

      var count = slider.scrollWidth > slider.clientWidth * 1.6 ? 3 : 2;
      if (dots.length === count) return;

      dotsWrap.textContent = '';
      dots = [];
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ami-dots__dot';
        dot.setAttribute(
          'aria-label',
          count === 2 ? labels[i === 0 ? 0 : 2] : labels[i]
        );
        dot.addEventListener('click', onDotClick(i));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
      update();
    }

    function onDotClick(index) {
      return function () {
        var target = (index / (dots.length - 1)) * maxScroll();
        // No explicit behavior: the ul's CSS scroll-behavior animates for
        // everyone else while reduced-motion users get an instant jump.
        slider.scrollTo({ left: target });
      };
    }

    function update() {
      if (!dots.length || dotsWrap.hidden) return;
      var range = maxScroll();
      var fraction = range > 0 ? slider.scrollLeft / range : 0;
      if (fraction >= 0.99) fraction = 1;
      var active = Math.round(fraction * (dots.length - 1));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('ami-dots__dot--active', i === active);
        if (i === active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    var ticking = false;
    slider.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          update();
        });
      },
      { passive: true }
    );

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        rebuild();
        update();
      }).observe(slider);
    }

    rebuild();
  }

  /* Hero slide buttons: copy each button's own text into data-ami-label so
   * the CSS "interactive hover button" (ami-modern-slideshow.css) can
   * restate it in its ::before/::after layers. Without this stamp the
   * attribute selector never matches and the stock button remains. */
  function stampSlideshowButtons() {
    document
      .querySelectorAll('slideshow-component.ami-modern .banner__buttons a.button')
      .forEach(function (btn) {
        if (btn.dataset.amiLabel) return;
        var label = (btn.textContent || '').trim();
        if (label) btn.dataset.amiLabel = label;
      });
  }

  function initAll() {
    document.querySelectorAll('slider-component').forEach(initSlider);
    stampSlideshowButtons();
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
